import React from 'react'

export function PiBackIcon() {
  return (
    <svg
      width='8'
      height='12'
      viewBox='0 0 8 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.24853 0.351344C7.4735 0.576377 7.59988 0.881547 7.59988 1.19974C7.59988 1.51794 7.4735 1.82311 7.24853 2.04814L3.29693 5.99974L7.24853 9.95134C7.46712 10.1777 7.58808 10.4808 7.58534 10.7954C7.58261 11.1101 7.4564 11.411 7.23391 11.6335C7.01143 11.856 6.71045 11.9822 6.39581 11.985C6.08118 11.9877 5.77806 11.8667 5.55173 11.6481L0.751734 6.84814C0.526769 6.62311 0.400391 6.31794 0.400391 5.99974C0.400391 5.68155 0.526769 5.37638 0.751734 5.15134L5.55173 0.351344C5.77677 0.126379 6.08194 0 6.40013 0C6.71833 0 7.0235 0.126379 7.24853 0.351344V0.351344Z'
        fill='#134C85'
      />
    </svg>
  )
}
